import { ArrowDown } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

const STEPS = [
  { n: "01", title: "LEARN THE P.E.E. GAME PLAN", desc: "Learn Position • Event • Entry, qualifying setups, events, entries, validation, risk, targets, session rules, and the complete execution framework." },
  { n: "02", title: "USE P.E.E. OS", desc: "Use technology built to help identify, organize, track, and measure the P.E.E. execution lifecycle." },
  { n: "03", title: "EXECUTE THE PROCESS", desc: "Trade according to predefined conditions rather than fear, FOMO, predictions, or impulse." },
  { n: "04", title: "REVIEW YOUR EXECUTION", desc: "Use trade review and analytics to study decisions, outcomes, strengths, weaknesses, and recurring patterns." },
  { n: "05", title: "REFINE & REPEAT", desc: "Apply what the data and reviews reveal, continue training, and improve through repetition and accountability." },
];

const LOOP = ["LEARN", "EXECUTE", "MEASURE", "IMPROVE", "BECOME THE EXECUTOR."];

export default function PathV2() {
  return (
    <section id="how-it-works" data-testid="path-section" className="border-t border-line bg-[#070809] py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="09 — The Path"
          testid="path-heading"
          title={
            <>
              The <span className="glow-text-neon text-neon">Executor</span> path.
            </>
          }
        />

        <div className="mt-14">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={0.06 * i}>
              <div
                data-testid={`path-step-${i}`}
                className="group grid grid-cols-[auto_1fr] items-baseline gap-6 border-t border-line py-8 transition-colors duration-500 last:border-b hover:bg-charcoal/40 sm:grid-cols-[100px_1fr_1.2fr] sm:gap-10 sm:px-6"
              >
                <span className="font-mono text-sm tracking-[0.2em] text-neon">{s.n}</span>
                <h3 className="font-display text-xl font-extrabold uppercase tracking-tight text-white sm:text-2xl">
                  {s.title}
                </h3>
                <p className="col-span-2 text-sm leading-relaxed text-mist sm:col-span-1">
                  {s.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 flex flex-col items-center gap-2 text-center">
          {LOOP.map((l, i) => (
            <Reveal key={l} delay={0.1 * i}>
              <div className="flex flex-col items-center gap-2">
                {i > 0 && <ArrowDown size={14} className="text-dim" />}
                <span
                  className={`font-mono uppercase tracking-[0.3em] ${
                    i === LOOP.length - 1
                      ? "glow-text-neon font-display text-2xl font-extrabold tracking-tight text-neon sm:text-3xl"
                      : "text-xs text-mist sm:text-sm"
                  }`}
                >
                  {l}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
